// This import loads the firebase namespace along with all its type information.
import CommentCreateUpdateArg from './comment-create-update-arg-model'

export async function load_commentCreateUpdateArgs(): Promise<
  CommentCreateUpdateArg[]
> {
  throw 'Not implemented'
}

export async function delete_commentCreateUpdateArg(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_commentCreateUpdateArg(): Promise<CommentCreateUpdateArg> {
  throw 'Not implemented'
}
